import { render } from "./messengerBody.vue?vue&type=template&id=cf8f1ec8&scoped=true"
import script from "./messengerBody.vue?vue&type=script&lang=js"
export * from "./messengerBody.vue?vue&type=script&lang=js"

import "./messengerBody.vue?vue&type=style&index=0&id=cf8f1ec8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf8f1ec8"]])

export default __exports__